import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerSearchService } from '../shared/customer-search.service';
import { IndividualSearchCriteria } from '../models/individual-search-criteria.model';
import { CustomerIdentificationType } from '../models/enums/customer-identification-type.enum';

@Component({
    selector: 'uspvsCheck',
    template: ''
})

export class UspvsCheckComponent extends BaseComponent {
    identificationType: CustomerIdentificationType = new CustomerIdentificationType();

    constructor(public _router: Router, public searchService: CustomerSearchService, private _route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        const criteria = new IndividualSearchCriteria();
        criteria.customerIdentificationTypeId = this.identificationType.LegacySequenceNumber.id;
        criteria.customerIdentificationValue = this._route.snapshot.params['LegacySequenceNumber'];
        if (criteria.customerIdentificationValue) {
            this.searchService.searchIndividuals(criteria).subscribe(
                result => {
                    if (result.results.length) {
                        const id = result.results[0].customerNumber;
                        this._router.navigateByUrl('/customer/individual/' + id + '/' + criteria.customerIdentificationValue + '/true');
                    } else {
                        this._router.navigateByUrl('/customer/search/' + criteria.customerIdentificationValue + '/true');
                    }
                },
                e => {
                    console.log(e);
                },
                () => {

                });
        }
    }
}
